import { reportError } from '../api'

export const isValidUrl = (url) => {
    try {
        if (url?.indexOf("http://") === 0 || url?.indexOf("https://") === 0) {
            return new URL(url)
        }
        else{
            return new URL(url, window.location.protocol + window.location.hostname)
        }
    } catch (e) {
      console.error(e)
      return false
    }
    // return true
  }

export const domainConverter = (iUrl) => {
    if (iUrl) {
        if (isValidUrl(iUrl)) {
            const url = new URL(iUrl)
            let host = url.hostname
            switch (window.location.hostname) {
                case 'localhost':
                case 'devwww.jostens.com':
                case 'dev1cms.jostens.com':
                    host = 'devwww.jostens.com'
                    break

                case 'testwww.jostens.com':
                    host = 'testwww.jostens.com'
                    break

                case 'demowww.jostens.com':
                    host = 'democdn.jostens.com'
                    break

                case 'qawww.jostens.com':
                    host = 'qacdn.jostens.com'
                    break

                case 'www.jostens.com':
                    host = 'cdn.jostens.com'
                    break

                default:
                    break;
            }
            return 'https://' + host + url.pathname + url.search + url.hash
        } else {
            return iUrl
        }
    }
    return null
}

export const imgUrlConverter = (iUrl, variantOption) => {
    if (iUrl) {
        const url = isValidUrl(iUrl)
        if(variantOption){
            url.search = url.search?.replace(/variant=[a-zA-Z_]+/, `variant=${variantOption}`)
        }
        if (url) {
            let host = url.hostname
            switch (window.location.hostname) {
                case 'localhost':
                case 'devwww.jostens.com':
                case 'dev1cms.jostens.com':
                case 'dev-jostens.dotcmscloud.com':
                case 'dev1cms-prochamp.jostens.com':
                case 'devwww.prochamp.jostens.com':
                case 'jostens-dev.dotcms.cloud':
                    host = 'devwww.jostens.com'
                    break
                
                case 'testwww.jostens.com':
                    host = 'testwww.jostens.com'
                    break
            
                case 'demowww.jostens.com':
                case 'uatcms-prochamp.jostens.com':
                case 'jostens-uat.dotcms.cloud':
                    host = 'democdn.jostens.com'
                    break
            
                case 'qawww.jostens.com':
                case 'jostens-auth.dotcms.cloud':
                    host = 'qacdn.jostens.com'
                    break
    
                case 'www.jostens.com':
                case 'jostens-prod.dotcms.cloud':
                    host = 'cdn.jostens.com'
                    break
    
                default:
                    break;
            }
            return url.protocol + '//' + host + url.pathname + url.search + url.hash
        } else {
            return iUrl
        }
    }
    return null
}

export const alternateUrlConverter = (aUrl) => {
    if (isValidUrl(aUrl)) { 
        return aUrl
    } else {
        return 'https://www.jostens.com' + aUrl
    }
}

export const actionUrlConverter = (aUrl) => {
    let host
    if (window.location.hostname === 'dev1cms.jostens.com' || window.location.hostname === 'localhost' 
        || window.location.hostname === 'dev-jostens.dotcmscloud.com' || window.location.hostname === 'dev1cms-prochamp.jostens.com'
        || window.location.hostname === 'devwww.prochamp.jostens.com') {
        host = 'devwww.prochamp.jostens.com'
    } else if (window.location.hostname === 'uatcms.jostens.com') {
        host = 'demowww.prochamp.jostens.com'
    }else if (window.location.hostname === 'authcms.jostens.com') {
        host = 'www.prochamp.jostens.com'
    } else {
        host = window.location.hostname
    }

    const url = isValidUrl(aUrl)
    if (url) {
        return window.location.protocol + '//' + host + url.pathname + url.search + url.hash
    } else {
        return window.location.protocol + '//' + host + aUrl
    }
}

export const hostUrlConverter = (aUrl) => {
    let host
    if (window.location.hostname === 'dev1cms.jostens.com' || window.location.hostname === 'localhost' || window.location.hostname === 'dev-jostens.dotcmscloud.com' 
        || window.location.hostname === 'devwww.prochamp.jostens.com') {
        host = 'devwww.jostens.com'
    } else if (window.location.hostname === 'uatcms.jostens.com') {
        host = 'demowww.jostens.com'
    }else if (window.location.hostname === 'authcms.jostens.com') {
        host = 'www.jostens.com'
    } else {
        host = window.location.hostname
    }

    const url = isValidUrl(aUrl)
    if (url) {
        return window.location.protocol + '//' + host + url.pathname + url.search + url.hash
    } else {
        return window.location.protocol + '//' + host + aUrl
    }
}

export const setCookie = (name, value, days = 7, path = '/') => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=${path}`
}
  
export const getCookie = (name) => {
    return document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=')
        return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, '')
}

export const deleteCookie = (name, path) => {
    setCookie(name, '', -1, path)
}

/**
 * Get customer number by parsing query string parameters 
 * @returns {string} path name parameter at 4th index
 */
export const getCustomerNumber = () => {
    const pathNameParts = window.location.pathname.split('/')
    return pathNameParts && pathNameParts[4]
}

/**
* Error logger to track braking exceptions and optionally redirect to error page
* @param {string} message - error message
* @param {string} rc - reason code for quick error tracking
* @param {boolean} shouldRedirect - should redirect to error page
*/
export const errorLogger = async (message, rc, shouldRedirect = true) => {
    if (window.location.hostname === "localhost") {
        console.error("Error:" + message);
        return;
    }

    const options = {
        customerNumber: getCustomerNumber(),
        appCustomer: 'package-browse-ui',
        src: window.location.href,
        occTimestamp: new Date().toString(),
        appEnvironment: navigator.userAgent,
        faultDetails: message
    }

    reportError(options)

    if (shouldRedirect) {
        window.location.href = `/apps/jcom/router.mvc?error=true&errorGroupName=${rc}`;
    }
}

export let settings = {
    accessibility: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    arrows: true,
    dots: false,
    variableWidth: false,
    adaptiveHeight: false,
    infinite: false,
    responsive: [
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: false,
                arrows: true,
                variableWidth: false
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false,
                arrows: true,
                variableWidth: false
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: false,
                arrows: true,
                variableWidth: false
            }
        }
    ]
}

export let packageProductsSliderSettings = {
    accessibility: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: true,
    dots: false,
    variableWidth: false,
    adaptiveHeight: false,
    infinite: false,
    responsive: [
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                variableWidth: false
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: false,
                arrows: true,
                variableWidth: false
            }
        }
    ]
}

export const container = {
    show: {
        transition: {
            staggerChildren: 0.2
        }
    }
}

export const product = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            duration: 0.25
        }
    }
}

export function formatDDMMMYY(ms) {
    if (!ms) return '';
    const date = new Date(ms);
    if (isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
    const year = String(date.getFullYear()).slice(-2);

    return `${day}-${month}-${year}`;
}

